import { useCallback } from 'react';

import { useAtom, useSetAtom } from 'jotai';

import { openFolderIdAtom } from '../../store/fileSystem.js';
import { isKnowledgeBaseOpenAtom } from '../../store/knowledgeBase.js';
import { ROOT_FOLDER_ID } from '../../types/fileSystem.js';

export const useKnowledgeBase = () => {
  const [isOpen, setIsOpen] = useAtom(isKnowledgeBaseOpenAtom);
  const setOpenFolderId = useSetAtom(openFolderIdAtom);

  const resetFolderPath = useCallback(() => {
    setOpenFolderId(ROOT_FOLDER_ID);
  }, [setOpenFolderId]);

  const toggle = useCallback(() => {
    if (isOpen) resetFolderPath();

    setIsOpen((prev) => !prev);
  }, [isOpen, setIsOpen, resetFolderPath]);

  const open = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const close = useCallback(() => {
    resetFolderPath();
    setIsOpen(false);
  }, [setIsOpen, resetFolderPath]);

  return { isOpen, toggle, open, close };
};
